<template>
  <div class="formbuilder">
    <b-navbar toggleable="lg" variant="light">
      <b-navbar-brand :href="app_path">{{ app_name }}</b-navbar-brand>
      <b-navbar-toggle target="nav-vfb-collapse"></b-navbar-toggle>
      <b-collapse id="nav-vfb-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item
            v-for="link in nav_links"
            :key="link.path"
            :to="app_path + link.path"
            :class="{ active: isCurrent(app_path + link.path) }"
          >
            {{ link.label }}
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      auth_user: this.$store.state.auth.is_auth,
      app_name: 'Конструктор форм',
      app_path: '/formbuilder',
      nav_links: [
        { path: '/form', label: 'Формы' },
        { path: '/record', label: 'Записи' }
      ]
    };
  },
  methods: {
    isCurrent(path) {
      var current_path = location.href.split('#')[1];
      return current_path === path;
    }
  },
  mounted() {
    let pageLoader = Vue.$loading.show();
    if (this.auth_user == true){
      pageLoader.hide();
    } else {
      this.$router.push('/');
      helper.toastErrorAuth();
      pageLoader.hide();
    }
  }
};
</script>

<style scoped>
.formbuilder {
}
</style>
